import React, { useState, useEffect } from "react";
import { View, StyleSheet } from "react-native";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import colors from "../config/colors";
import NtText from "./NtText";
import NtTextInput from "./NtTextInput";
import NtDropDownSelectContainer from "./NtDropDownSelectContainer";
import NtModalUnactiveButton from "./NtModalUnactiveButton";
import NtModalActiveButton from "./NtModalActiveButton";
import NtModalTitle from "./NtModalTitle";
import NtModalSubtitle from "./NtModalSubtitle";

function NtDatePickerModal({
  title = "Date Picker",
  subtitle = "Select date below",
  isTimeEnabled = false,
  date,
  onSelect,
  onCancel,
}) {
  const options = [
    { value: "00:00:00", title: "12:00 AM" },
    { value: "01:00:00", title: "01:00 AM" },
    { value: "02:00:00", title: "02:00 AM" },
    { value: "03:00:00", title: "03:00 AM" },
    { value: "04:00:00", title: "04:00 AM" },
    { value: "05:00:00", title: "05:00 AM" },
    { value: "06:00:00", title: "06:00 AM" },
    { value: "07:00:00", title: "07:00 AM" },
    { value: "08:00:00", title: "08:00 AM" },
    { value: "09:00:00", title: "09:00 AM" },
    { value: "10:00:00", title: "10:00 AM" },
    { value: "11:00:00", title: "11:00 AM" },
    { value: "12:00:00", title: "12:00 PM" },
    { value: "13:00:00", title: "01:00 PM" },
    { value: "14:00:00", title: "02:00 PM" },
    { value: "15:00:00", title: "03:00 PM" },
    { value: "16:00:00", title: "04:00 PM" },
    { value: "17:00:00", title: "05:00 PM" },
    { value: "18:00:00", title: "06:00 PM" },
    { value: "19:00:00", title: "07:00 PM" },
    { value: "20:00:00", title: "08:00 PM" },
    { value: "21:00:00", title: "09:00 PM" },
    { value: "22:00:00", title: "10:00 PM" },
    { value: "23:00:00", title: "11:00 PM" },
  ];

  const [selectedDate, setSelectedDate] = useState(date);
  const [selectedTime, setSelectedTime] = useState(options[0]);

  const isRequiredFields = () => {
    return selectedDate && selectedTime;
  };

  useEffect(() => {
    //will try the time.....
    if (isTimeEnabled && date?.getHours()) {
      const time =
        date?.getHours() < 10
          ? `0${date?.getHours()}:00:00`
          : `${date?.getHours()}:00:00`;
      const hour = options.find((each) => each.value == time);
      if (hour) {
        setSelectedTime(hour);
      }
    }
  }, []);

  return (
    <View style={styles.container}>
      <NtModalTitle>{title}</NtModalTitle>
      <NtModalSubtitle style={[{ marginTop: 4, marginBottom: 25 }]}>
        {subtitle}
      </NtModalSubtitle>

      {isTimeEnabled && (
        <div style={{ maxWidth: 200, marginBottom: 25 }}>
          <NtDropDownSelectContainer
            containerStyle={{}}
            title={"Select Time *"}
            data={options}
            selection={selectedTime}
            onSelect={(option) => {
              setSelectedTime(option);
            }}
          />
        </div>
      )}

      <DayPicker
        mode="single"
        selected={selectedDate}
        onSelect={(date) => setSelectedDate(date)}
        defaultMonth={selectedDate}
      />

      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: 25,
        }}
      >
        <NtModalUnactiveButton title={"Cancel"} onPress={onCancel} />
        <NtModalActiveButton
          containerStyle={{ marginLeft: 15 }}
          title={"Select"}
          onPress={() => {
            if (isRequiredFields()) {
              if (isTimeEnabled) {
                selectedDate.setHours(
                  selectedTime.value.split(":")[0],
                  selectedTime.value.split(":")[1],
                  selectedTime.value.split(":")[2]
                );
              }

              onSelect(selectedDate);
            }
          }}
          enabled={isRequiredFields()}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 15,
  },
  input: {
    marginRight: 10,
    marginLeft: 6,
    flex: 1,
    paddingVertical: 0,
    outlineColor: colors.lighter,
    outlineStyle: "none",
  },
});

export default NtDatePickerModal;
